import React, { useState } from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import { Box, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Form, Input, Modal, Select, Space } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import { Add, Delete } from '@mui/icons-material';
import Datas from "../../../Data/Data.json"
import { useAuthHeader } from '../../../Services/Auth/sessionAuth';
import SweetAlert from "sweetalert2";
import { MoneyOffCsredOutlined } from '@mui/icons-material';
import Data from '../../../Data/Data.json';
import OptionSelect from '../../../Types/OptionSelect';

interface DataType {
  key: number;
  NUMCPT: string;
  CODREL: string;
  LIMITE: number;
  Nomrel?: string;
  TelRel?: string;
  photo?: string;
  signature?: string;
}


function Tab4(props: { form?: any, OptionSignataire?: OptionSelect[] }) {
  // const [agences,SetAgences]=React.useState<SelectData[]>([]);
  // const [profils,SetProfils]=React.useState<SelectData[]>([]);
  const [Donnee, setDonnee] = React.useState<DataType[]>([]);
  const [pageIsLoad, setPageIsLoad] = useState(true);
  //   const [loadingAgence, setLoadaingAgence] = useState(true);
  const [loadingProfil, setLoadaingProfil] = useState(true);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');


  const [codage, setCodage] = useState<string>();
  const [Limite, setLIMITE] = useState<number>();

  // USER TOKEN
  const authHeader = useAuthHeader()

  // if(localStorage.length == 0){
  //   setDonnee([])
  // }


  const columns: ColumnsType<DataType> = [
    {
      title: 'Compte',
      dataIndex: 'NUMCPT',
      ellipsis: true,
      width: 150,
      render: (text) => <a>{text}</a>
    },
    {
      title: 'Code relation',
      dataIndex: 'CODREL',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Ratio',
      dataIndex: 'LIMITE',
      ellipsis: true,
      width: 150,
      render: (_, text) => (<span>
        {text.LIMITE} %
      </span>)
    },
    {
      title: 'Nom Relation',
      dataIndex: 'Nomrel',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Tel Rel',
      dataIndex: 'TelRel',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Photo',
      dataIndex: 'photo',
      ellipsis: true,
      width: 150,
      render: (text: any, record: any) => (
        <span>
          <img
            onClick={e => { setPreviewImage(record.photo); setPreviewTitle("Preview Image"); setPreviewOpen(true); }}
            style={{ height: 50, width: 50 }}
            src={record.photo}
          ></img>
        </span>)
    },
    {
      title: 'Signature',
      dataIndex: 'signature',
      ellipsis: true,
      width: 150,
      render: (text: any, record: any) => (
        <span>
          <img
            onClick={e => { setPreviewImage(record.signature); setPreviewTitle("Preview Image"); setPreviewOpen(true); }}
            style={{ height: 50, width: 50 }}
            src={record.signature}
          ></img>
        </span>)
    }
    ,
    {
      title: 'Action',
      ellipsis: true,
      width: 100,
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title='Retirer de la liste'>
            <Button color='error' icon={<Delete color='error' />} onClick={() => {
              let newRows: DataType[] = [];
              Donnee.map((d) => {
                if (!(d.CODREL === record.CODREL && d.LIMITE === record.LIMITE)) {
                  newRows.push(d)
                }

                setDonnee(newRows);
              })

              setDonnee(newRows)
              localStorage.setItem(Data.LocalVariable.AyantDCompte, JSON.stringify(newRows))
              //localStorage.setItem(Datas.LocalVariable.groupPlanCp, Crypter.encrypt(JSON.stringify(d)))
            }} />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: 'CNI',
      dataIndex: 'cni',
      ellipsis: true,
      width: 150,

    }
  ];

  const handleChangeAgence = (value: string) => {
    setCodage(value);
  };
  const handleChangeGroupe = (e: any) => {
    setLIMITE(parseInt(e.target.value));
    //alert(e.target.value)
  };

  if (pageIsLoad) {
    setPageIsLoad(false)
  }


  function add() {
    if (codage && Limite) {
  
      // alert(Limite);

      if (Limite <= 100) {
        if (Limite > 0) 
        {
            let total: number = 0;
            Donnee.forEach((data: any) => {
              total += data.LIMITE;
            });

      
         if ((total + Limite) <= 100) {
        //  if ((total) <= 100) {
          // alert(total)
          const newData: DataType = {
            key: 0,
            NUMCPT: props.form.getFieldValue("NUMCPT"),
            CODREL: codage,
            LIMITE: Limite
          };

          if (Donnee.find((d) => d.CODREL == codage)) {
            SweetAlert.fire({ title: "Attention", text: "Cette configuration existe déjà", icon: "warning" })
          }
          else if (Donnee.find((d) => d.CODREL == codage)) {
            SweetAlert.fire({ title: "Attention", text: "Ce signataire existe déjà", icon: "warning" })
          }
          else {
            setDonnee([...Donnee, newData]);
            localStorage.setItem(Data.LocalVariable.AyantDCompte, JSON.stringify([...Donnee, newData]))
            console.log(Donnee)
          }
        }
        else {
          SweetAlert.fire({ title: "Attention", text:"le total dépasse  100% ", icon: "warning" })
        }
        
      }
        else {
          SweetAlert.fire({ title: "Attention", text: "Comment 0 %", icon: "error" })
        }

      }
      else {
        SweetAlert.fire({ title: "Attention", text: "Pas plus de 100%", icon: "warning" })
      }
    }
    else {
      SweetAlert.fire({ title: "Attention", text: "Veillez sélectionner les éléments indiqués", icon: "warning" })
    }
  }



// lors de la creation du client 
//Catégot 

  function loadData() {
    try {

      setDonnee([]);
      let data = JSON.parse(localStorage.getItem(Datas.LocalVariable.AyantDCompte) + "");
      if (data !== null) setDonnee(data);

    } catch (error) {
      console.log(error)
    }
  }
  setTimeout(() => {

    try {

      let reset = localStorage.getItem(Datas.LocalVariable.AyantDCompte)
      if (reset == null) {
        setDonnee([])
      } else {
        loadData();
      }
    }
    catch (error) {
      console.log(error)
    }
  }, 1);


  return (
    <div className='tabItem'>
      <div>
        <Box fontStyle="inherit">
          <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
            <Box display={"flex"} className="border-left" fontStyle="inherit" >
              <Box className="border-left" >
                <label htmlFor=""><b>Ayant Droit </b></label>
                <Select
                  onChange={handleChangeAgence}
                  value={codage}
                  id='codage'
                  size='middle'
                  style={{ width: 300 }}
                  options={props.OptionSignataire}
                />
              </Box>
              <Box sx={{ marginTop: -1 }} className="border-left" >
                <InputForm  notRequired icon={<MoneyOffCsredOutlined/>} onChange={handleChangeGroupe}   label='Quote-part de la Ralation %' name='plafond' type='number' ></InputForm>
              </Box>
              <Box className="border-left" ><Button onClick={add} style={{ width: 100 }} size='large' icon={<Add color='success' />} /></Box>
            </Box>
            <legend>Ayant droit Habilité Au Compte</legend>
            <div>
              <Table size='small' columns={columns} pagination={{ pageSize: 5, position: ["bottomRight"] }} dataSource={Donnee} scroll={{ y: 350, x: 1000 }} />
            </div>
          </Box>
        </Box>
        <Modal width={800} open={previewOpen} title={previewTitle} footer={null} onCancel={e => setPreviewOpen(false)}>
          <img alt="example" style={{ width: '100%', maxHeight: 500 }} src={previewImage} />
        </Modal>
      </div>
    </div>
  );
}

export default Tab4;